import type { ProcessChartProps } from './types';

/**
 * BarChart — 공정 현황 차트의 대안 형태(공종별 가로 막대). 노선도(RouteMapChart)와 교체 가능한 예시.
 * 교체: ./index.ts 의 ProcessChart 대상을 이 파일로 바꾸면 본 화면 차트가 이 형태로 바뀐다.
 */

const STATUS_META: Record<string, { label: string; color: string; pct: number }> = {
  done: { label: '완료', color: 'var(--color-success)', pct: 100 },
  active: { label: '시공중', color: 'var(--color-info)', pct: 55 },
  finish: { label: '완공', color: 'var(--shell-on-surface)', pct: 0 },
  pending: { label: '시작전', color: 'var(--shell-border)', pct: 0 },
};

export function BarChart({ steps }: ProcessChartProps) {
  return (
    <div className="space-y-1.5 pt-1">
      {steps.map((s) => {
        const m = STATUS_META[s.status] ?? STATUS_META.pending;
        return (
          <div key={s.name} className="flex items-center gap-2">
            <span className="w-12 shrink-0 truncate text-[length:var(--type-caption-size)] text-text-secondary">{s.name}</span>
            <div className="h-2 flex-1 overflow-hidden rounded-full bg-surface-muted">
              <div className="h-full rounded-full" style={{ width: `${m.pct}%`, background: m.color }} />
            </div>
            <span className="w-16 shrink-0 text-right text-[length:var(--type-caption-size)] text-text-muted">{s.date}</span>
          </div>
        );
      })}
    </div>
  );
}
